// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select--CKSdn","Space":"Space--2g8MB","Icon":"Icon--1Tm9L"};